var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('SidebarProductEntry',{ref:"entry",on:{"init":_vm.init,"add":function($event){return _vm.$router.push({name: 'create-domain'})},"loadEntries":_vm.loadEntries,"urlChange":s => _vm.$emit('urlChange', s)}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }